import { Home, Info, Mail, MessageSquare, FileText, Workflow, BarChart3, Brain, Shield } from 'lucide-react';

export const navItems = [
    { label: 'Home', path: '/', icon: <Home className="w-6 h-6" /> },
    { label: 'Business Solutions', path: '/business-solutions', icon: <FileText className="w-6 h-6" /> },
    { label: 'Automation', path: '/automation', icon: <Workflow className="w-6 h-6" /> },
    { label: 'Dashboards', path: '/dashboards', icon: <BarChart3 className="w-6 h-6" /> },
    { label: 'AI Chatbots', path: '/ai-chatbots', icon: <MessageSquare className="w-6 h-6" /> },
    { label: 'AI Solutions', path: '/ai-solutions', icon: <Brain className="w-6 h-6" /> },
//    { label: 'Security', path: '/security', icon: <Shield className="w-6 h-6" /> },
    { label: 'About Us', path: '/about', icon: <Info className="w-6 h-6" /> },
    { label: 'Contact', path: '/contact', icon: <Mail className="w-6 h-6" /> },
];